import { render, staticRenderFns } from "./PartnerFooter.vue?vue&type=template&id=7efcdc3a"
import script from "./PartnerFooter.vue?vue&type=script&lang=ts"
export * from "./PartnerFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports